import React from 'react';
import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';
import { useFavorites } from '../../context/FavoritesContext';

const FloatingFavorites = () => {
    const { favoritesCount } = useFavorites();

    return (
        <Link
            to="/favorites"
            className="fixed bottom-6 right-6 lg:bottom-10 lg:right-10 z-50 p-4 bg-white hover:bg-slate-50 text-slate-600 hover:text-brand rounded-full shadow-2xl border border-slate-100 transition-all duration-300 hover:scale-110 group flex items-center justify-center"
            title="Mes Favoris"
        >
            <Heart className="w-6 h-6 sm:w-7 sm:h-7 transition-colors group-hover:text-brand group-hover:fill-brand/10" />
            {favoritesCount > 0 && (
                <span className="absolute -top-1 -right-1 sm:-top-2 sm:-right-2 w-5 h-5 sm:w-6 sm:h-6 bg-brand text-white text-[10px] sm:text-xs font-bold flex items-center justify-center rounded-full shadow-md border-2 border-white">
                    {favoritesCount}
                </span>
            )}
        </Link>
    );
};

export default FloatingFavorites;
